// Interne Module
import { get } from '@/_helper/storage.jsx';
import { PaymentType } from '@/model/common/PaymentType';

export default class PaymentError extends Error {
    protected bookingNumber: string;
    protected paymentType: string;
    protected transactionIdentifier: string | undefined;
    protected spsErrors: Error[] | undefined;

    constructor(message: string, paymentType: PaymentType, transactionIdentifier?: string, spsErrors?: Error[]) {
        super(message);
        this.name = 'PaymentException';
        this.bookingNumber = get('bookingNumber');
        this.paymentType = paymentType;
        this.transactionIdentifier = transactionIdentifier;
        this.spsErrors = spsErrors;
    }

    public toString() {
        return JSON.stringify(this);
    }
}
